import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { type LightBoxOfferInfoDto } from "@modules/boxOffer/gateway/boxOfferDto"
import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"

export class LightBoxOfferInfoEntity {
  id: string
  name: string
  price: PriceObjectEntity | null
  type: BoxOfferType
  recurringPeriod?: string | null

  private constructor(lightBoxOfferInfo: LightBoxOfferInfoEntity) {
    this.id = lightBoxOfferInfo.id
    this.name = lightBoxOfferInfo.name
    this.price = lightBoxOfferInfo.price
    this.type = lightBoxOfferInfo.type
    this.recurringPeriod = lightBoxOfferInfo.recurringPeriod
  }

  static fromDto(dto: LightBoxOfferInfoDto): LightBoxOfferInfoEntity {
    return new LightBoxOfferInfoEntity({
      id: dto.id,
      name: dto.name,
      price: dto.price ? PriceObjectEntity.fromDto(dto.price) : null,
      type: dto.type,
      recurringPeriod: dto.recurringPeriod ?? null,
    })
  }
}
